"use strict";

module.exports = {
  'name': 'distance',
  'category': 'Geometry',
  'syntax': ['distance([x1, y1], [x2, y2])', 'distance([[x1, y1], [x2, y2])'],
  'description': 'Calculates the Euclidean distance between two points.',
  'examples': ['distance([0,0], [4,4])', 'distance([[0,0], [4,4]])'],
  'seealso': []
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/expression/embeddedDocs/function/geometry/distance.js
// module id = 877
// module chunks = 0